import { render, staticRenderFns } from "./classroomInfo.vue?vue&type=template&id=d731c3da&scoped=true"
import script from "./classroomInfo.vue?vue&type=script&lang=js"
export * from "./classroomInfo.vue?vue&type=script&lang=js"
import style0 from "./classroomInfo.vue?vue&type=style&index=0&id=d731c3da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d731c3da",
  null
  
)

export default component.exports